const refreshTag = 'refresh';

export class RefreshEvents {
    addRefreshListener(callback) {
        document.addEventListener(refreshTag, callback);
    }

    dispatchRefreshEvent() {
        document.dispatchEvent(new Event(refreshTag));
    }

    removeRefreshListener(callback) {
        document.removeEventListener(refreshTag, callback);
    }
}
